import axios from "@/plugins/axios";

export function getCommentListByQuery(token, query) {
  return axios({
    url: "/Site/GetCommentsWithRepliesAsync",
    method: "GET",
    headers: {
      Authorization: token,
    },
    params: {
      ...query,
      pageIndex: query.pageNum,
    },
  });
}

export function submitComment(token, form) {
  return axios({
    url: "/Site/SubmitCommentsWithRepliesAsync",
    method: "POST",
    headers: {
      Authorization: token,
    },
    data: {
      // ...form,
    },
    params: {
      blogId: form.blogId,
      content: form.content,
      email: form.email,
      nickName: form.nickName,
      notice: form.notice,
      page: form.page,
      parentCommentId: form.parentCommentId,
      website: form.website,
    },
  });
}
